// extracted by mini-css-extract-plugin
module.exports = {"infoCard":"info-card_infoCard_2aiwN","infoItem":"info-card_infoItem_1d5RY","name":"info-card_name_1bElR"};